/**
 * store for ide
 */

import questionApi from '../../api/question'
import answerApi from '../../api/answer'
import { emitEvent } from '../../utils/eventBus/vueEvent'
import Events from '../../scripts/events/index'
import iframe from '../../scripts/iframe/index'
import Language from '../../scripts/common/language'
import Env from '../../scripts/common/env'
import {showErr} from "../../scripts/message";
import consoleStyle from '../../components/ide/consoleStyle'
import Question from "../../scripts/common/question";
const Base64 = require('js-base64').Base64
import aegis from '../../scripts/aegis'

export const getQceitQuery = (query, params) => {
  return {
    userId: query.user_uid,
    examTId: query.exam_tid,
    examId: query.exam_uid,
    questionId: query.problem_id,
    examGradeId: query.exam_grade_uid,
    qceitQuestionUid: query.question_uid,
    questionScore: query.question_score,
    token: query.token,
    questionCode: query.question_code,
    timestamp: query.timestamp,
    ip: query.ip,
    ttoken: query.ttoken,
    ...params
  }
}

const initTime = Date.now()

const ideData = {
  state: {
    context: null,
    questionInfo: { ProgramItem: {}, Question: {} },
    questionInfoReady: false,
    questionLoadErr: false,
    ideCode: null,
    prevCode: null,
    answerList: [],
    runToken: '-',
    runningData: {},
    isEdit: false,
    isRunning: false,
    isRunLocal: 0, // 是否skulpt运行环境，true 时是的；
    isPyRuntimeCom: false, // 是否通过使用本地skulpt com，false 时标示使用iframe方式加载；
    isTesting: false,
    isSkulptDraw: false,
    ideReady: false,
    isLocalIde: true, // 是否通过使用本地ide com，false 时标示使用iframe方式加载；
    skulptReady: false,
    language: Language.c,
  },
  mutations: {
    SET_CONTEXT: (state, context) => {
      if (context) {
        state.context = context
      } else {
        console.error('SET_CONTEXT:', context)
      }
    },
    SET_QUESTIONINFO: (state, questionInfo) => {
      if (questionInfo) {
        state.questionInfo = questionInfo
      } else {
        console.error('SET_QUESTIONINFO:', questionInfo)
      }
    },
    SET_QUESTIONINFOREADY: (state, questionInfoReady) => {
      state.questionInfoReady = questionInfoReady
    },
    SET_QUESTIONLOADERR: (state, questionLoadErr) => {
      state.questionLoadErr = questionLoadErr
    },
    SET_IDECODE: (state, ideCode) => {
      state.ideCode = ideCode
    },
    SET_PREVCODE: (state, prevCode) => {
      state.prevCode = prevCode
    },
    SET_ANSWERLIST: (state, answerList) => {
      state.answerList = answerList
    },
    SET_RUNTOKEN: (state, runToken) => {
      state.runToken = runToken
    },
    SET_RUNNINGDATA: (state, runningData) => {
      state.runningData = runningData
    },
    SET_ISEDIT: (state, isEdit) => {
      state.isEdit = isEdit
    },
    SET_ISRUNNING: (state, isRunning) => {
      state.isRunning = isRunning
    },
    SET_ISTESTING: (state, isTesting) => {
      state.isTesting = isTesting
    },
    SET_IDEREADY: (state, ideReady) => {
      state.ideReady = ideReady
    },
    SET_ISLOCALIDE: (state, isLocalIde) => {
      state.isLocalIde = isLocalIde
    },
    SET_SKULPTREADY: (state, skulptReady) => {
      state.skulptReady = skulptReady
    },
    SET_ISRUNLOCAL: (state, isRunLocal) => {
      state.isRunLocal = isRunLocal
    },
    SET_ISPYRUNTIMECOM: (state, isPyRuntimeCom) => {
      state.isPyRuntimeCom = isPyRuntimeCom
    },
    SET_ISSKULPTDRAW: (state, isSkulptDraw) => {
      state.isSkulptDraw = isSkulptDraw
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
    },
  },
  actions: {
    setContext({ commit }, context) {
      console.log('--setContext:', context)
      commit('SET_CONTEXT', context)
    },

    /**
     * 获取题目信息
     * @param commit
     * @param state
     * @param data query数据
     * @returns {Promise<void>}
     */
    async getQuestionInfo({ commit, state }, data) {
      const params = getQceitQuery(data)
      const QuestionID = parseInt(params.questionId || 0, 10)
      if (!QuestionID) {
        showErr(`getQuestionInfo err: QuestionID = ${QuestionID}`)
        aegis.report('getQuestionInfo err: QuestionID')
        return
      }
      commit('SET_QUESTIONINFO', { ProgramItem: {}, Question: { QuestionID } })
      const res = await questionApi.questionInfo(params)
      if (res.Code === 0) {
        if (res.data) {
          res.data.ProgramItem = res.data.Question && res.data.Question.Data && JSON.parse(res.data.Question.Data) || {}
          commit('SET_QUESTIONINFO', res.data)
          commit('SET_QUESTIONINFOREADY', true)
          if (res.data.ProgramItem && res.data.ProgramItem.Ext) {
            res.data.ProgramItem.Ext = JSON.parse(res.data.ProgramItem.Ext) || {}
            // 是否是python skulpt 绘图
            if (res.data.ProgramItem.Ext.skulptType == 3) {
              commit('SET_ISSKULPTDRAW', true)
            }
            // 是否是python 服务器运行
            if (res.data.ProgramItem.Ext.runType == 1) {
              commit('SET_ISRUNLOCAL', 0)
            }
            // SET_ISLOCALIDE (这里逻辑问使用人工处理，而是在异常时自动切成本地)
            if (res.data.ProgramItem.Ext.localIde == 2) {
              commit('SET_ISLOCALIDE', false)
            }
          }
        } else {
          console.error('getQuestionInfo err0:', res)
          commit('SET_QUESTIONLOADERR', true)
        }
      } else if (res.Code !== 403001) {
        state.context.$message.error(res.Msg)
        commit('SET_QUESTIONLOADERR', true)
        console.error('getQuestionInfo err1:', res)
        if (res.Code == 4013 || res.Code == 4014) {
          emitEvent(Events.OUTPUT_CONSOLE, `用户权限异常，请尝试重新登录系统: ${res.Code}`)
        }
        aegis.report(`getQuestionInfo err1: ${JSON.stringify(res)}`)
      } else {
        commit('SET_QUESTIONLOADERR', true)
        console.error('getQuestionInfo err403001:', res)
        aegis.report('getQuestionInfo err403001')
      }
    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     * @returns {Promise<void>}
     */
    async getNewestCode({ commit, state }, data) {
      const params = getQceitQuery(data, {isEdit: state.isEdit});
      if (state.isEdit) {
        try {
          const key = Question.getCacheCodeKey(params.userId, params.examTId, params.questionId, params.examGradeId)
          const cache = (localStorage && localStorage.getItem(key)) || null
          if (cache) {
            commit('SET_IDECODE', cache)
            commit('SET_PREVCODE', cache)
            if (state.ideReady) {
              iframe.setIdeCode(cache, state.isLocalIde)
            }
            return
          }
        } catch (e) {
          console.error('getNewestCode window.localStorage getItem err:', e)
        }
      } else {
        console.log('--loadCode online--')
      }
      const res = await answerApi.getAnswer(params)
      if (res.Code === 0) {
        if (res.data && res.data.Code) {
          // res.data.Time
          const code = Base64.decode(res.data.Code)
          commit('SET_IDECODE', code)
          commit('SET_PREVCODE', code)
          if (state.ideReady) {
            iframe.setIdeCode(code, state.isLocalIde)
          }
        } else {
          console.info('getNewestCode null', res)
        }
      } else {
        state.context.$message.error(`代码加载失败：${res.Code},${res.Msg}`)
        console.error('getNewestCode err1:', res, data)
        aegis.report(`getNewestCode err1: ${JSON.stringify(res)}`)
      }
    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     * @returns {Promise<void>}
     */
    async getTestCodeInfo({ commit, state }, { test, message }) {
      const code = Base64.decode(test.Code)
      commit('SET_IDECODE', code)
      commit('SET_PREVCODE', code)
      if (state.ideReady) {
        iframe.setIdeCode(code, state.isLocalIde)
      }
      emitEvent(Events.OUTPUT_CONSOLE, `切换成测试的代码: ${message}`, 1)
    },

    /**
     *
     * @param commit
     * @param state
     * @param data
     * https://qceit-kaoji.coding.qq.com/c-judge?
     problem_id=20772
     &user_uid=c94b54cc-fce6-4214-9a46-66703dfc1f22
     &exam_uid=bf69a224-01f4-4cff-a3a2-cd0c13b9631e
     &exam_grade_uid=17ad8558-50ec-4b80-b0ed-fb52fda1b124
     &question_uid=df4bdb53-0ea2-4258-8904-01f4a30df54c
     &question_code=0913-01
     &question_score=20.00
     &timestamp=1602728949
     &token=c896bf20a3fec647a2927303b1fb441c
     &d=2020-10-15-10-29-10
     * @returns {Promise<boolean>}
     */
    async getAnswerList({ commit, state }, data) {

      // python 不需要加载 测试列表；
      if (state.language.value === Language.py.value) {
        return
      }

      const params = getQceitQuery(data)
      const res = await answerApi.testList(params)
      if (res.Code !== 0) {
        state.context.$message.error(`测试列表加载失败：${res.Code},${res.Msg}`)
        console.error('getAnswerList err1:', res)
        aegis.report(`getAnswerList err1: ${JSON.stringify(res)}`)
        return
      } else if (!res.data) {
        console.error('getAnswerList err:', res)
        aegis.report(`getAnswerList err: ${JSON.stringify(res)}`)
        return
      }
      const arr = res.data.TestList || []
      commit('SET_ANSWERLIST', arr)
    },

    async saveCode({ state, commit }, { code, query, saveType }) {
      if (!state.isEdit) {
        return
      }
      if (code == state.prevCode) {
        if (saveType != iframe.TYPE_AUTO_SAVE) {
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave('...保存成功') })
          console.log('saveCode any saveType: ', saveType)
        }
        return
      } else {
        console.log('saveCode saveType: ', saveType)
      }
      const params = getQceitQuery(query, {code: Base64.encode(code)});
      const res = await answerApi.save(params)
      console.log('saveCode:', res);
      if (res.Code === 0) {
        commit('SET_PREVCODE', code)
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave(saveType == iframe.TYPE_AUTO_SAVE ? '代码已保存' : '...保存成功') })
      } else {
        console.error('saveCode err:', res)
        state.context.$message.error(res.Msg)
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr(saveType == iframe.TYPE_AUTO_SAVE ? '代码保存失败' : '...保存失败') })
        aegis.report(`saveCode err: ${JSON.stringify(res)}`)
      }
    },

    saveCodeLocal({ state }, { code, query, saveType }) {
      if (!state.isEdit) {
        return
      }
      if (!window.localStorage) {
        console.warn('window.localStorage is null...', state.isRunning)
        return
      }
      const params = getQceitQuery(query)
      try {
        const key = Question.getCacheCodeKey(params.userId, params.examTId, params.questionId, params.examGradeId)
        const cache = localStorage.getItem(key)
        if (cache == code) {
          console.log('saveCodeLocal code same')
          return
        }
        localStorage.setItem(key, code)
        console.log('window.localStorage setItem ok:', saveType)
      } catch (e) {
        console.error('window.localStorage setItem err:', e)
      }
    },

    async commitCode({ state }, { code, query, callback }) {
      if (!state.isEdit) {
        callback && callback({ Code: 0 })
        return
      }
      if (!code) {
        // 提交
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave('...代码为空，保存完成') })
        callback && callback({ Code: 0 })
        return
      }
      const params = getQceitQuery(query, {code: Base64.encode(code), isEdit: state.isEdit});
      const res = await answerApi.commit(params)
      if (res.Code === 0) {
        // 提交
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave('...保存成功') })

        aegis.reportT({
          name: 'init-commitCode',
          duration: Math.round((Date.now() - initTime) /10),
          ext1: state.language.key,
          ext2: String(state.isLocalIde),
          ext3: String(state.isPyRuntimeCom)
        })
      } else {
        console.error('commitCode err:', res, state.isRunning)
        // 提交
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('...保存失败') })
        aegis.report(`commitCode err: ${JSON.stringify(res)}`)
      }
      callback && callback(res)
    },
    setRunningData({ commit }, {addr, running, runToken, sessionId}) {
      commit('SET_RUNNINGDATA', {addr, running, runToken, sessionId})
      commit('SET_RUNTOKEN', runToken)
    },
    setIsRunning({ commit }, isRunning) {
      commit('SET_ISRUNNING', isRunning)
    },
    setIsTesting({ commit }, isTesting) {
      commit('SET_ISTESTING', isTesting)
    },
    setCode({ commit }, { ideCode, prevCode }) {
      if (ideCode || ideCode === '') {
        commit('SET_IDECODE', ideCode)
      }
      if (prevCode || prevCode === '') {
        commit('SET_PREVCODE', prevCode)
      }
    },
    setIdeReady({ commit, state }, ideReady) {
      commit('SET_IDEREADY', ideReady)
      if (ideReady && state.ideCode) {
        iframe.setIdeCode(state.ideCode, state.isLocalIde)
      }
      aegis.reportT({
        name: 'init-IdeReady',
        duration: Date.now() - initTime,
        ext1: state.language.key,
        ext2: String(state.isLocalIde),
        ext3: String(state.isPyRuntimeCom)
      })
    },
    setSkulptReady({ commit, state }, skulptReady) {
      commit('SET_SKULPTREADY', skulptReady)
      aegis.reportT({
        name: 'init-SkulptReady',
        duration: Date.now() - initTime,
        ext1: state.language.key,
        ext2: String(state.isLocalIde),
        ext3: String(state.isPyRuntimeCom)
      })
    },
    setIsPyRuntimeCom({ commit }, isPyRuntimeCom) {
      commit('SET_ISPYRUNTIMECOM', isPyRuntimeCom)
    },
    setIsLocalIde({ commit }, isLocalIde) {
      commit('SET_ISLOCALIDE', isLocalIde)
    },
    initQuery({ commit }, query) {
      const ip = Env.signBit.getQueryIp(query)

      // init editable
      const isEdit = ip & Env.signBit.save || ip & Env.signBit.commit
      if (isEdit) {
        if (window != top) {
          commit('SET_ISEDIT', true)
        }
      }

      // init language
      const key = query && query.lang
      const lang = (key && Language[key]) || Language.c
      commit('SET_LANGUAGE', lang)
      if (lang.value === Language.py.value) {
        commit('SET_ISRUNLOCAL', ip & Env.signBit.rlocal || !isEdit)
      }
    },
  },
  getters: {
    questionInfo: state => state.questionInfo,
    questionInfoReady: state => state.questionInfoReady,
    questionLoadErr: state => state.questionLoadErr,
    ideCode: state => state.ideCode,
    prevCode: state => state.prevCode,
    answerList: state => state.answerList,
    runToken: state => state.runToken,
    runningData: state => state.runningData,
    isEdit: state => state.isEdit,
    isRunning: state => state.isRunning,
    isTesting: state => state.isTesting,
    ideReady: state => state.ideReady,
    skulptReady: state => state.skulptReady,
    isRunLocal: state => state.isRunLocal,
    isSkulptDraw: state => state.isSkulptDraw,
    language: state => state.language,
    isLocalIde: state => state.isLocalIde,
    isPyRuntimeCom: state => state.isPyRuntimeCom,
  }
}

export default ideData
